class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.querySelectorAll('details details').forEach((submenu) => {
      submenu.addEventListener('mouseenter', () => this.openMenu(submenu));
      submenu.addEventListener('mouseleave', () => this.closeMenu(submenu));
    });
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  openMenu(menu) {
    if (!this.isDesktop()) return;

    menu.setAttribute('open', '');
    menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
  }

  closeMenu(menu) {
    if (!this.isDesktop()) return;

    menu.removeAttribute('open');
    menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    menu.querySelectorAll('details[open]').forEach((submenu) => {
      submenu.removeAttribute('open');
      submenu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    });
  }

  onMouseEnter() {
    if (!this.isDesktop()) return;

    window.clearTimeout(this.closeTimeout);

    document.querySelectorAll('header-menu > details[open]').forEach((menu) => {
      if (menu !== this.mainDetailsToggle) menu.removeAttribute('open');
    });
    this.openMenu(this.mainDetailsToggle);
  }

  onMouseLeave() {
    if (!this.isDesktop()) return;

    window.clearTimeout(this.closeTimeout);
    this.closeTimeout = window.setTimeout(() => {
      this.closeMenu(this.mainDetailsToggle);
    }, 300);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
